import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { Button, ModalContext, SidebarModal } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useAgency from '@hooks/useAgency'
import useServices from '@hooks/useServices'

import ServiceListItem from './components/ServiceListItem'

const ManageAgencyTemplatesModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, updateAgencyTemplatePermissions } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const { agency } = digObject(modalData, modalKey, {})

  const agencyPayload = useAgency(agency)
  const {
    callbacks: {
      updateTemplatePermissions: updateFn,
    },
  } = agencyPayload

  const { filteredServices } = useServices({
    filters: { filterTemplatable: true },
  })

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header
        callbacks={callbacks}
        title="Assign all"
        titleSecondLine="Template Pages"
      />

      <SidebarModal.Content>
        {filteredServices.map(service => (
          <ServiceListItem
            callbacks={{
              toggleTemplatePermissions: permissionAction => (
                updateAgencyTemplatePermissions(permissionAction, service.id, updateFn)
              ),
            }}
            key={service.id}
            title={service.title}
          />
        ))}
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          onClick={() => closeModal()}
          size="large"
        >
          Close Template Pages
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

ManageAgencyTemplatesModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

ManageAgencyTemplatesModal.defaultProps = {
  modalKey: 'ManageAgencyTemplatesModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <ManageAgencyTemplatesModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
